// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import shortid from "shortid";
import { StorageProviderFactory, IStorageProvider } from "../providers/storage/storageProviderFactory";
import {
    IProject, ITag, ISecurityToken, AppError,
    ErrorCode,
    FieldType,
    FieldFormat,
    IField,
    IFieldInfo,
} from "../models/applicationState";
import ServiceHelper from "./serviceHelper";
import Guard from "../common/guard";
import { constants } from "../common/constants";
import { decryptProject, encryptProject, joinPath, patch, getNextColor } from "../common/utils";
import packageJson from "../../package.json";
import { strings, interpolate } from "../common/strings";
import { toast } from "react-toastify";
import { headers, analysisGetEndPoint , accessToken, refreshTokenEndPoint, refreshTokenCall
    ,analysisCVGetEndPoint,analysisCustomVisionGetEndPoint,analysisCustomVisionTriggerGetEndPoint
} from "../common/api-config";

// tslint:disable-next-line:no-var-requires
const tagColors = require("../react/components/common/tagColors.json");


/**
 * Functions required for a project service
 * @member save - Save a project
 * @member delete - Delete a project
 */
export interface IProjectService {
    
    getAnalyseResultData(modelName: string, analysis: string): Promise<void>;

    getCVAnalyseResultData(modelName: string, analysis: string, projectid:string): Promise<void>;
    getCustomVisionAnalyseResultData(project_name:string,user_id:string ): Promise<void>;
    analysisCustomVisionTriggerResultData(projectid:string,project_name:string,user_id:string,isTrainigDone: string,training_type: string ): Promise<void>;


}

/**
 * @name - Project Service
 * @description - Functions for dealing with projects
 */
export default class AnalysisService implements IProjectService {
    
    public getAnalyseResultData = async (modelName: string, analysis: string) => {
        let headers = accessToken()
        const endpointURL = analysisGetEndPoint(modelName,analysis)
        let response;
        try {
            response = await ServiceHelper.getWithAutoRetry(
                endpointURL, { headers });
            return response.data;
        } catch (err) {
            let response;
            if(err.response.status == 401){
                const body = {
                    refreshToken: refreshTokenCall()
                }
                response = await ServiceHelper.postWithAutoRetry(
                    refreshTokenEndPoint(), body, { headers });
                if(response.data.status == 200){
                    const signInUserSession = localStorage.getItem("signInUserSession");
                    const user = signInUserSession && JSON.parse(signInUserSession);
                    const updateAccessToken = Object.assign({}, user)
                    updateAccessToken.access_token = response.data.access_token
                    updateAccessToken.refresh_token = response.data.refresh_token
                    try {
                        response = await ServiceHelper.getWithAutoRetry(
                            endpointURL, { headers });
                        return response.data;
                    } catch (err) {
                        ServiceHelper.handleServiceError(err);
                    }

                }
            }else{
                ServiceHelper.handleServiceError(err);
            }
        }
    }

    public getCVAnalyseResultData = async (modelName: string, analysis: string, projectid:string) => {
        let headers = accessToken()
      //  const endpointURL = analysisCVGetEndPoint(modelName,analysis,projectid,iterationName)

     //const  iterationName = "test1";
     const  iterationName = "iteration-"+shortid.generate();

     //debugger;

      const endpointURL = analysisCVGetEndPoint(projectid,iterationName);
      console.log("endpointURL", endpointURL);
        let response;
        try {
           response = await ServiceHelper.getWithAutoRetry(
                endpointURL, { headers });

              /*  response = await ServiceHelper.postWithAutoRetry(
                    endpointURL, { headers });*/
                    console.log("result"+JSON.stringify(response.data));
            return response.data;
        } catch (err) {
            let response;
            if(err.response.status == 401){
                const body = {
                    refreshToken: refreshTokenCall()
                }
                response = await ServiceHelper.postWithAutoRetry(
                    refreshTokenEndPoint(), body, { headers });
                if(response.data.status == 200){
                    const signInUserSession = localStorage.getItem("signInUserSession");
                    const user = signInUserSession && JSON.parse(signInUserSession);
                    const updateAccessToken = Object.assign({}, user)
                    updateAccessToken.access_token = response.data.access_token
                    updateAccessToken.refresh_token = response.data.refresh_token
                    try {
                        response = await ServiceHelper.getWithAutoRetry(
                            endpointURL, { headers });
                        return response.data;
                    } catch (err) {
                        ServiceHelper.handleServiceError(err);
                    }

                }
            }else{
                ServiceHelper.handleServiceError(err);
            }
        }
    }

public getCustomVisionAnalyseResultData = async (project_name:string,user_id:string) => {
    let headers = accessToken()
  //  const endpointURL = analysisCVGetEndPoint(modelName,analysis,projectid,iterationName)

 //const  iterationName = "test1";
 const  iterationName = "iteration-"+shortid.generate();

 //debugger;
 
  const endpointURL = analysisCustomVisionGetEndPoint(project_name,user_id);
  //const endpointURL = analysisCustomVisionTriggerGetEndPoint();
  
  console.log("endpointURL", endpointURL);
    let response;
    try {
      /* response = await ServiceHelper.getWithAutoRetry(
            endpointURL, { headers });*/
            const body = {                                 
                  //  projectid:projectid,
                  //  iterationName:iterationName,
                   // project_name:project_name,
                   // user_id:user_id,
                  //  training_type:"Regular",
                  //  training_duration:0
                
            }
            response = await ServiceHelper.postWithAutoRetry(
                endpointURL, body, { headers });
         //   return response.data;
/*
           response = await ServiceHelper.postWithAutoRetry(
                endpointURL, { headers });*/
                console.log("  train result"+JSON.stringify(response.data));
        return response.data;
    } catch (err) {
        let response;
        if(err.response.status == 401){
            const body = {
                refreshToken: refreshTokenCall()
            }
            response = await ServiceHelper.postWithAutoRetry(
                refreshTokenEndPoint(), body, { headers });
            if(response.data.status == 200){
                const signInUserSession = localStorage.getItem("signInUserSession");
                const user = signInUserSession && JSON.parse(signInUserSession);
                const updateAccessToken = Object.assign({}, user)
                updateAccessToken.access_token = response.data.access_token
                updateAccessToken.refresh_token = response.data.refresh_token
                try {
                    response = await ServiceHelper.getWithAutoRetry(
                        endpointURL, { headers });
                    return response.data;
                } catch (err) {
                    ServiceHelper.handleServiceError(err);
                }

            }
        }else{
            ServiceHelper.handleServiceError(err);
        }
    }
}

public analysisCustomVisionTriggerResultData = async (projectid:string,project_name:string,user_id:string,training_type: string, isTrainigDone: string) => {
    let headers = accessToken()
  //  const endpointURL = analysisCVGetEndPoint(modelName,analysis,projectid,iterationName)

 //const  iterationName = "test1";
 const  iterationName = "iteration-"+shortid.generate();

 //debugger;
 
  //const endpointURL = analysisCustomVisionGetEndPoint(projectid,iterationName,project_name,user_id,training_type,0, isTrainigDone);
  const endpointURL = analysisCustomVisionTriggerGetEndPoint(projectid);
  
  console.log("endpointURL", endpointURL);
    let response;
    try {
      /* response = await ServiceHelper.getWithAutoRetry(
            endpointURL, { headers });*/
            const body = {                                 
                    projectid:projectid,
                    iterationName:iterationName,
                    project_name:project_name,
                    user_id:user_id,
                    training_type:"Regular",
                    training_duration:0
                
            }
            response = await ServiceHelper.postWithAutoRetry(
                endpointURL, body, { headers });
         //   return response.data;
/*
           response = await ServiceHelper.postWithAutoRetry(
                endpointURL, { headers });*/
                console.log("  train result"+JSON.stringify(response.data));
        return response.data;
    } catch (err) {
        let response;
        if(err.response.status == 401){
            const body = {
                refreshToken: refreshTokenCall()
            }
            response = await ServiceHelper.postWithAutoRetry(
                refreshTokenEndPoint(), body, { headers });
            if(response.data.status == 200){
                const signInUserSession = localStorage.getItem("signInUserSession");
                const user = signInUserSession && JSON.parse(signInUserSession);
                const updateAccessToken = Object.assign({}, user)
                updateAccessToken.access_token = response.data.access_token
                updateAccessToken.refresh_token = response.data.refresh_token
                try {
                    response = await ServiceHelper.getWithAutoRetry(
                        endpointURL, { headers });
                    return response.data;
                } catch (err) {
                    ServiceHelper.handleServiceError(err);
                }

            }
        }else{
            ServiceHelper.handleServiceError(err);
        }
    }
}






}
